class InPageMenu extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('.in-page-menu__mobile-button'),
      menu: this.querySelector('.in-page-menu__list'),
    };
    this.elements.button.addEventListener('click', debounce(this.handleClick.bind(this), 100));
  }

  handleClick(event) {
    this.elements.menu.classList.toggle('open');
    this.elements.button.ariaExpanded = this.elements.button.ariaExpanded !== 'true';
  }
}

customElements.define('in-page-menu', InPageMenu);
